import { Trophy, Medal, SealCheck, BookOpen, Calculator, Star } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import { XPBadge, CoinBadge, StreakBadge, AchievementBadge, TrophyCard } from "../rewards";

export function RewardsSection() {
  return (
    <SectionShell
      id="rewards"
      eyebrow="Rewards"
      eyebrowIcon={Trophy}
      title="Little celebrations of effort"
      description="Reward visuals make progress feel special. They celebrate effort and curiosity — the economy comes later; here we define only the warm, collectable look."
    >
      <div className="space-y-5">
        <Showcase title="Badges">
          <div className="flex flex-wrap items-center gap-3">
            <XPBadge amount={15} />
            <XPBadge amount={250} />
            <CoinBadge amount={120} />
            <StreakBadge days={7} />
            <XPBadge amount={5} size="sm" />
            <CoinBadge amount={30} size="sm" />
          </div>
        </Showcase>

        <Showcase title="Achievement badges" description="Unlocked & locked" tone="muted">
          <div className="flex flex-wrap gap-6">
            <AchievementBadge icon={BookOpen} label="Star Reader" color="teal" />
            <AchievementBadge icon={Calculator} label="Number Ninja" color="blue" />
            <AchievementBadge icon={Star} label="Perfect Week" color="secondary" />
            <AchievementBadge icon={SealCheck} label="Explorer" color="primary" />
            <AchievementBadge icon={Medal} label="Locked" unlocked={false} />
          </div>
        </Showcase>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <Showcase title="Trophy card"><TrophyCard /></Showcase>
          <Showcase title="Trophy card"><TrophyCard title="Reading Star" subtitle="10 stories finished!" /></Showcase>
        </div>
      </div>
    </SectionShell>
  );
}

export default RewardsSection;
